module.exports = __webpack_public_path__ + "img/ionic.1cf76cf5.svg";